import SyncIcon from "@mui/icons-material/Sync";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";
import DefaultApiService from "../../../../../infrastructure/api/default";
import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import CustomMap from "../../../../components/map/CustomMap";
import toMapMarkerData from "../../../../components/map/mapMarkerUtils";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";

const MapReportPage = () => {
  const pageInfo = useGetPageInfo();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    list: [],
    config: {
      center: [32.68, 51.68],
      zoom: 9,
      mapServiceKind: "Default",
    },
  });

  //   console.log("data", data);

  useEffect(() => {
    if (data.list.length === 0) onGetData();
  }, []);

  const onGetData = async () => {
    setLoading(true);
    const res = await DefaultApiService.getApi("DG/Management/Map/GetData");
    // console.log("res", res);
    setLoading(false);
    setData(res.data);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <IconButton
                  variant="text"
                  color="primary"
                  onClick={() => onGetData()}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />
          <CardContent>
            <Grid container>
              <Grid item xs={12} md={12} sx={{ position: "relative" }}>
                <CustomMap
                  loading={loading}
                  {...data.config}
                  markers={toMapMarkerData(data.list)}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default MapReportPage;
